import get from 'lodash/get'

// Matches curly brackets in strings
const CURLY_REGEX = /{([^{}\s]+)}/g

const interpolateAnswerData = (str: string, answers: object) => {
  let newStr = str
  let execResult: RegExpExecArray

  do {
    execResult = CURLY_REGEX.exec(str)

    if (!execResult) continue

    let extractedAnswer: any
    const [match, propertyToInterpolate] = execResult

    try {
      // Use `lodash/get` for more complex object nesting (i.e. secondary
      // addresses or co-borrower name)
      extractedAnswer = get(answers, propertyToInterpolate)
    } catch (err) {
      extractedAnswer = null
      console.error(`No property found for: ${propertyToInterpolate}`)
    }

    // Fall back to simple answer extraction if not a deeply nested
    // variable or if there was an error
    const calculateInterpolatedAnswer = (): string => {
      if (propertyToInterpolate === 'firstName' && extractedAnswer) {
        return ` ${extractedAnswer}`
      }
      return extractedAnswer ?? answers[propertyToInterpolate] ?? ''
    }

    const interpolatedAnswer = calculateInterpolatedAnswer()

    if (interpolatedAnswer === null || interpolatedAnswer === undefined) {
      console.error(
        'Failed to interpolate string. Property not found in answers object.',
        { propertyToInterpolate, answers }
      )
    }

    newStr = newStr.replace(match, interpolatedAnswer)
  } while (execResult)

  return newStr
}

export default interpolateAnswerData
